<template>
    <div>
        <Alert :alert="alert" />

        <div v-if="loading" class="d-flex flex-spaced-fixed">
            <div class="cr-spinner-small"></div>
            <p>Aguarde uns instantes...</p>
        </div>

        <div v-show="!loading">
            <ul v-show="!storeState.payment.selectedMethod" class="checkout-options pt-2">
                <li v-for="(method, index) in paymentMethodsList">
                    <input
                        :id="`method-${index}`"
                        :checked="storeState.payment.selectedMethod === method"
                        class="cr-radio"
                        type="radio"
                    />
                    <label
                        :for="`method-${index}`"
                        style="align-items: center"
                        @click="selectMethod(method)"
                        class="flex-grid"
                    >
                        <div
                            :class="{ 'pl-0': storeState.payment.selectedMethod }"
                            class="checkout-option-content flex-xs-12"
                        >
                            <p>{{ method.label }}</p>
                        </div>
                    </label>
                </li>
            </ul>

            <keep-alive>
                <component
                    :is="
                        storeState.payment.selectedMethod
                            ? componentsMap[storeState.payment.selectedMethod.module]
                            : null
                    "
                    v-show="storeState.payment.selectedMethod"
                    :cart="cart"
                    :customer="customer"
                    :payment-methods="paymentMethods"
                    @error="showError"
                    @allow-checkout="$emit('allow-checkout')"
                />
            </keep-alive>
        </div>
    </div>
</template>

<script>
    import Alert from '../../../../submodules/src/componentsV2/surface/alert/Alert.vue';
    import BaseCheckoutPayment from './common/BaseCheckoutPayment.vue';

    export default {
        name: 'CheckoutPayment',

        extends: BaseCheckoutPayment,

        components: {
            Alert,
        },
    };
</script>
